import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getCompanyFuelSettings(options = {}) {
	return _apiRequestWrap(
		ModulesMap.COMPANY_FUEL_SETTINGS,
		ModulesConfigMap[ModulesMap.COMPANY_FUEL_SETTINGS].GET_COMPANY_FUEL_SETTINGS,
		options
	)
}

function _patchCompanyFuelSettings(options = {}) {
	return _apiRequestWrap(
		ModulesMap.COMPANY_FUEL_SETTINGS,
		ModulesConfigMap[ModulesMap.COMPANY_FUEL_SETTINGS].PATCH_COMPANY_FUEL_SETTINGS,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.COMPANY_FUEL_SETTINGS].GET_COMPANY_FUEL_SETTINGS]: _getCompanyFuelSettings,
	[ModulesConfigMap[ModulesMap.COMPANY_FUEL_SETTINGS].PATCH_COMPANY_FUEL_SETTINGS]: _patchCompanyFuelSettings,
}
